import { createStyles, makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    details: {
      fontSize: 17
    },
    flexContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexDirection: 'column',
      maxWidth: '500px',
      backgroundColor: 'white',
      minHeight: '80vh',
      borderRadius: '10px'
    }
  })
)
